import { Endpoints } from "../../../constants/endpoints";
import { TJobQuoteRaw } from "./types";
import client from "../../client";

export const getJobQuote = (jobId: number | number) => async () => {
  const { data } = await client.get<TJobQuoteRaw>(Endpoints.getJobQuote(jobId));
  return data;
};
